.bq{overflow:hidden;}